import React from 'react';
import { useSelector } from 'react-redux';

import BoxPlot from 'components/BoxPlot';
import AlertPanel from 'components/AlertPanel';

import {
  getHasCategoricalVariablesEmptyCell,
  getHasNumericalVariablesEmptyCell,
  getNumericalRowDataSet,
  getCategoricalRowDataSet,
  isAnovaDataSetScenario
} from 'store/scenes/inferentialStatistics/selectors';
import {
  getFrequencyDataSetLength,
  getFilteredParameterValues,
  getFilteredParametersValuesNotEmpty,
  getVisibleNumericalSelectedParametersNames,
  getVisibleCategoricalSelectedParametersNames
} from 'store/dataset';

import { getBoxPlotData } from 'calculators/graphicalStatistics/boxPlot';

export const SideBySideBoxPlots = () => {
  const numericalRowDataSet = useSelector(state => getNumericalRowDataSet(state));
  const categoricalRowDataSet = useSelector(state => getCategoricalRowDataSet(state));
  const isDataSetMode = useSelector(state => isAnovaDataSetScenario(state));

  const boxPlotData = useSelector(state => {

    const isDataSetScenario =
    getVisibleNumericalSelectedParametersNames(state).length > 0 &&
    getVisibleCategoricalSelectedParametersNames(state).length > 0 &&
    getFrequencyDataSetLength(state) === 0;

    if (isDataSetScenario) {
      const hasDataEmptyCells = getHasNumericalVariablesEmptyCell(state) || getHasCategoricalVariablesEmptyCell(state);
      let numericalVariable = [];
      let categoricalVariable = [];

      if (hasDataEmptyCells) {
        const variables = getFilteredParametersValuesNotEmpty(state, numericalRowDataSet, categoricalRowDataSet);
        numericalVariable = variables.firstParsedParameterValues;
        categoricalVariable = variables.secondParsedParameterValues;
      } else {
        numericalVariable = getFilteredParameterValues(state, numericalRowDataSet);
        categoricalVariable = getFilteredParameterValues(state, categoricalRowDataSet);
      }
      return getBoxPlotData(numericalVariable, categoricalVariable);
    }
    return null;
  });

  return (
    <div>
      { isDataSetMode
        ? (
          <BoxPlot
            boxes={boxPlotData}
            yAxisLabel={numericalRowDataSet}
            xAxisLabel={categoricalRowDataSet}
          />
        )
        : (
          <AlertPanel
            variant="warning"
            errMsg="Side-by-Side Boxplots are not available for summarized data."
            className="mt-5"
          />)
      }
    </div>
  );
};
